// 宣传资料图片
import FACEBOOK from './facebook.png';
import GOOGLE from './google.png';
import INSTAGRAM from './instagram.png';
import TIK_TOK from './tik_tok.png';
import TRIP_ADVISOR from './trip_advisor.png';
import TWITTER from './twitter.png';
import WHATSAPP from './whatsapp.png';

const propaganda = {
    FACEBOOK, GOOGLE, INSTAGRAM, TIK_TOK, TRIP_ADVISOR, TWITTER, WHATSAPP
}

export default propaganda